var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"word_container"},[_c('el-button',{staticClass:"el-icon-full-screen word_container_button",on:{"click":_vm.fullScreen}}),_c('div',{ref:"word",attrs:{"id":"wordViewer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }